import { useRecoilValue, useSetRecoilState } from 'recoil'
import { productsState, stepState } from '../states/messageState'
import { useCheckAddress } from './useCheckAddress'
import { useInViewFooter } from './useInViewFooter'
import { useSendMessage } from './useSendMessage'

export const useCheckPhone = () => {
  const { handleAddSenderParent } = useSendMessage()
  const products = useRecoilValue(productsState)
  const { checkAddress } = useCheckAddress()
  const { handleInViewFooter } = useInViewFooter()
  const setCurrentStep = useSetRecoilState(stepState)

  /**電話番号の有無をチェック。登録済みの場合、住所の確認に進む */
  const checkPhone = async (isChangeAddress: boolean) => {
    const hasPhone = products.some(({ hasPhone }) => hasPhone)
    if (hasPhone) {
      await checkAddress(isChangeAddress)
    } else {
      await handleAddSenderParent('bot', 'ハイフン付きで電話番号を登録してください')
      handleInViewFooter()
      setCurrentStep('inputUpdatePhone')
    }
  }

  return { checkPhone }
}
